module.exports = __webpack_public_path__ + "static/media/009.4da69f28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/009.jpg
// module id = 516
// module chunks = 0